import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppConfig } from '@shared/utils/app-config';
import { translateConfiguration, TranslationFromJsonService } from './services/translate-from-json.service';
import { SharedDataAccessModule } from '@shared/data-access';

@NgModule({
  imports: [
    CommonModule,
    SharedDataAccessModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationFromJsonService,
        deps: [HttpClient, AppConfig],
      },
      extend: true,
    }),
  ],
  exports: [TranslateModule],
  providers: [provideAppInitializer(() => {
        const initializerFn = (translateConfiguration)(inject(TranslateService), inject(Injector), inject(AppConfig));
        return initializerFn();
      })],
})
export class SharedFeatureTranslateModule {}

@NgModule({
  imports: [
    CommonModule,
    SharedDataAccessModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationFromJsonService,
        deps: [HttpClient, AppConfig],
      },
      isolate: false,
    }),
  ],
  exports: [TranslateModule],
  providers: [provideAppInitializer(() => {
        const initializerFn = (translateConfiguration)(inject(TranslateService), inject(Injector), inject(AppConfig));
        return initializerFn();
      })],
})
export class SharedFeatureTranslateRootModule {}
